import React, { PropTypes, Component } from 'react'
import moment from 'moment-timezone'

import './AvailabilityCalendarPage.scss'
import Day from './components/AvailabilityCalendarDay'

class AvailabilityCalendarPage extends Component {
  getDaysInPage ({ page, daysPerPage, availability }) {
    let lower = page * daysPerPage
    let upper = lower + daysPerPage
    return Object.keys(availability).sort().slice(lower, upper)
  }

  addFillInDaysIfNeccessary (days, daysPerPage) {
    const result = [].concat(days)
    const format = 'Y-MM-DD'

    while (result.length < daysPerPage) {
      let lastResult = result[result.length - 1]
      let nextResult = moment(lastResult).add(1, 'days')
      result.push(nextResult.format(format))
    }

    return result
  }

  getDayAvailability (availability) {
    return day => {
      const unavailableDay = {date: moment(day), availability: []}

      const isFillDay = !(day in availability)
      if (isFillDay) {
        return unavailableDay
      }

      const hasDayAvailability = availability[day].availability.some(slot => slot.available)
      return hasDayAvailability ? availability[day] : unavailableDay
    }
  }

  createDay ({selectedDate, onChange}) {
    return (availability, index) => (
      <Day
        key={index}
        selectedDate={selectedDate}
        onChange={onChange}
        availability={availability}
        />
    )
  }

  render () {
    const {
      selectedDate,
      onChange,
      availability,
      page,
      daysPerPage
    } = this.props

    let daysInPage = this.getDaysInPage({ page, daysPerPage, availability })
    daysInPage = this.addFillInDaysIfNeccessary(daysInPage, daysPerPage)
    const days = daysInPage
                  .map(this.getDayAvailability(availability))
                  .map(this.createDay({ selectedDate, onChange }))

    return (
      <div className='AvailabilityCalendarPage'>
        {days}
      </div>
    )
  }
}

AvailabilityCalendarPage.displayName = 'AvailabilityCalendarPage'
AvailabilityCalendarPage.propTypes = {
  selectedDate: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  daysPerPage: PropTypes.number.isRequired,
  availability: PropTypes.object.isRequired
}

export default AvailabilityCalendarPage



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/AvailabilityCalendarPage/AvailabilityCalendarPage.js